/* eslint-disable no-shadow */
import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import PropTypes from 'prop-types';

import Button from '../../../componentLibrary/Button';
import SaveButton from './SaveButton';
import { APPLICATION_MODES } from '../../../constants/itemTypes/itemTypes';
import * as Styled from './styles';
import * as PreviewStyled from '../../Preview/styles';
import UndoRedo from '../UndoRedo/UndoRedo';

const DESKTOP_VIEW_WIDTH = '100%';
const MOBILE_VIEW_WIDTH = '310px';

const TopNavLeftSideActions = ({ setPreviewWidth, setApplicationMode, applicationMode }) => (
    <>
        {/* TODO: PIK-2203 Cleanup prop drilling */}
        {applicationMode === APPLICATION_MODES.EDITOR && (
            <Styled.TopNavDiv data-test-id="top-left-nav-actions">
                <UndoRedo applicationMode={applicationMode} />
                <SaveButton setApplicationMode={setApplicationMode} />
            </Styled.TopNavDiv>
        )}
        {/* TODO: PIK-2203 Cleanup prop drilling */}
        {applicationMode === APPLICATION_MODES.PREVIEW && (
            <Styled.TopNavDiv data-test-id="top-left-nav-actions">
                <PreviewStyled.PreviewWidthContainer>
                    <Button
                        label="Desktop"
                        ariaLabel="Set Desktop Preview Mode"
                        data-tip
                        data-for="desktopView"
                        type="simple"
                        width={38}
                        iconSize={15}
                        iconPadding={8}
                        icon="laptop"
                        marginBottom={13}
                        onClick={setPreviewWidth(DESKTOP_VIEW_WIDTH)}
                    />
                    <PreviewStyled.ViewIconSpacer />
                    <Button
                        label="Mobile"
                        ariaLabel="Set Mobile Preview Mode"
                        data-tip
                        data-for="mobileView"
                        type="simple"
                        width={38}
                        iconSize={17}
                        iconPadding={7}
                        marginBottom={13}
                        icon="mobile-alt"
                        onClick={setPreviewWidth(MOBILE_VIEW_WIDTH)}
                    />
                </PreviewStyled.PreviewWidthContainer>
            </Styled.TopNavDiv>
        )}

        {/* TODO: PIK-2203 Cleanup prop drilling */}
        {applicationMode === APPLICATION_MODES.VERSION_HISTORY && (
            <Styled.TopNavDiv data-test-id="top-left-nav-actions">
                <Styled.VersionHistoryHeader>Version history</Styled.VersionHistoryHeader>
            </Styled.TopNavDiv>
        )}
    </>
);

const mapStateToProps = (state) => ({
    controls: _get(state, 'session.controls', []),
});

TopNavLeftSideActions.propTypes = {
    applicationMode: PropTypes.string.isRequired,
    setApplicationMode: PropTypes.func.isRequired,
    setPreviewWidth: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(TopNavLeftSideActions);
